// Generated by purs version 0.13.8
"use strict";
var Data_Functor = require("/usr/src/app/www/.spago/prelude/v4.1.1/src/Data/Functor.purs");
var Data_Nullable = require("/usr/src/app/www/.spago/nullable/v4.1.1/src/Data/Nullable.purs");
var Data_Semigroup = require("/usr/src/app/www/.spago/prelude/v4.1.1/src/Data/Semigroup.purs");
var Data_String_Common = require("/usr/src/app/www/.spago/strings/v4.0.2/src/Data/String/Common.purs");
var Lib_Components_Bio = require("/usr/src/app/www/src/Lib/Components/Bio.purs");
var Lib_Components_Layout = require("/usr/src/app/www/src/Lib/Components/Layout.purs");
var Lib_Components_Seo = require("/usr/src/app/www/src/Lib/Components/SEO.purs");
var Lib_Packages_Gatsby_Link = require("/usr/src/app/www/src/Lib/Packages/Gatsby/Link.purs");
var Lib_Utils_Typography = require("/usr/src/app/www/src/Lib/Utils/Typography.purs");
var React_Basic_DOM = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM.purs");
var React_Basic_DOM_Generated = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM/Generated.purs");
var React_Basic_DOM_Internal = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM/Internal.purs");
var index = function (props) {
    var post = function (edge) {
        return React_Basic_DOM_Generated.article()({
            key: edge.node.fields.slug,
            children: [ React_Basic_DOM_Generated.header_([ React_Basic_DOM_Generated.h3()({
                style: React_Basic_DOM_Internal.css({
                    marginBottom: Lib_Utils_Typography.rhythm(1.0 / 4.0)
                }),
                children: [ Lib_Packages_Gatsby_Link.link({
                    style: React_Basic_DOM_Internal.css({
                        boxShadow: "none"
                    }),
                    to: edge.node.fields.slug,
                    children: [ React_Basic_DOM.text(edge.node.frontmatter.title) ]
                }) ]
            }), React_Basic_DOM_Generated.small_([ React_Basic_DOM.text(edge.node.frontmatter.date) ]) ]), React_Basic_DOM_Generated.section_([ React_Basic_DOM_Generated.p()({
                dangerouslySetInnerHTML: {
                    "__html": (function () {
                        var $0 = Data_String_Common["null"](edge.node.frontmatter.description);
                        if ($0) {
                            return edge.node.frontmatter.description;
                        };
                        return edge.node.excerpt;
                    })()
                }
            }) ]) ]
        });
    };
    var postsComponents = Data_Functor.map(Data_Functor.functorArray)(post)(props.data.allMarkdownRemark.edges);
    return React_Basic_DOM_Generated.div_([ Lib_Components_Layout.layout({
        children: Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Lib_Components_Seo.seo({
            title: Data_Nullable.notNull("All Posts"),
            meta: Data_Nullable["null"],
            lang: Data_Nullable["null"],
            author: Data_Nullable["null"],
            metaDescription: Data_Nullable["null"]
        }), Lib_Components_Bio.bio({
            avatar: props.data.avatar,
            site: props.data.site
        }) ])(postsComponents),
        year: "2020",
        location: props.location,
        title: props.data.site.siteMetadata.title
    }) ]);
};
module.exports = {
    index: index
};

